var SearchConfigurationService = (function () {
    function SearchConfigurationService($http) {
        this.$http = $http;
    }
    SearchConfigurationService.prototype.get = function () {
        return this.$http
            .get('compatibilityguide/ng-settings/feature/search/listoptions')
            .then(function (response) { return response.data; });
    };
    SearchConfigurationService.$inject = ['$http'];
    return SearchConfigurationService;
}());
export { SearchConfigurationService };
